import { gql } from "@apollo/client";
import React, { useCallback } from "react";

import { Txt } from "../../hex-components";
import { useQueryParams } from "../../route/routes";

import { useAuthorizeCliDeviceMutation } from "./CliAuthFlow.generated";
import { CliAuthFlowScreen } from "./CliAuthFlowScreen";
import { CliLogo } from "./CliLogo";

gql`
  mutation AuthorizeCliDevice($userCode: String!, $action: CliDeviceAction!) {
    authorizeCliDevice(userCode: $userCode, action: $action) {
      action
    }
  }
`;

export const CliAuthFlow: React.ComponentType = React.memo(
  function CliAuthFlow() {
    const [authorizeCliDevice, authorizeCliDeviceResult] =
      useAuthorizeCliDeviceMutation();
    const completedAction =
      authorizeCliDeviceResult.data?.authorizeCliDevice.action;

    const onAuthorize = useCallback(
      async (userCode: string, approve: boolean) => {
        await authorizeCliDevice({
          variables: {
            userCode,
            action: approve ? "APPROVE" : "DENY",
          },
        });
      },
      [authorizeCliDevice],
    );

    const userCodeFromUrl = useQueryParams().get("user_code");
    const errorMessage = authorizeCliDeviceResult.error?.message;

    return (
      <>
        <CliLogo />

        {!completedAction && (
          <CliAuthFlowScreen.ConfirmUserCode
            userCode={userCodeFromUrl}
            onAuthorize={onAuthorize}
          />
        )}
        {completedAction === "APPROVE" && <CliAuthFlowScreen.Approved />}
        {completedAction === "DENY" && <CliAuthFlowScreen.Denied />}

        {errorMessage && <Txt css="margin-top: 16px;">{errorMessage}</Txt>}
      </>
    );
  },
);
